/* eslint react/no-direct-mutation-state: "off", 'no-redeclare': 'off','no-loop-func':'off','no-dupe-keys':'off', eqeqeq: 'off' */
import React, { Component } from "react";
import { Button, Label } from "reactstrap";
import { connect } from "react-redux";
import ReactDOM from 'react-dom';  
import { GetWorkOrderBuildings, BuildingUnAssociation, ChangeDisplayinWorkOrderTenant, GetBuildingAssociation } from '../../../../action/workorderAction';
import SearchableSpaceDropDown from './MultiSelectSearchableDropDown';


class TenantAssociation extends Component {
    componentWillMount(){
        this.props.GetWorkOrderBuildings();
        const actionResponse = this.props.GetBuildingAssociation(this.props.AssociaTetenantId);
            actionResponse.then((result) => {
               if(this.props.getTenantAssociations !== undefined && this.props.getTenantAssociations.length){
                    this.FormTreeData(this.props.getTenantAssociations);
               }
        })
    }

    componentWillReceiveProps(nextProps)
    {
        if (this.props != nextProps) {
            this.setState({ tenant_buildings_state: nextProps.getTenantAssociations });
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('wheel', this.handleMouseScroll);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('wheel', this.handleMouseScroll);
    }

    handleClickOutside(event) {
        if(this.spaceWrapperRef && !this.spaceWrapperRef.contains(event.target)){
            let SStateChange = {...this.state.SpacesDropDownStyles};
            SStateChange.display = "none";
            this.setState({SpacesDropDownStyles:SStateChange}); 
        }
    }

    handleMouseScroll(event){
        if(this.spaceWrapperRef && !this.spaceWrapperRef.contains(event.target)){
            let SStateChange = {...this.state.SpacesDropDownStyles};
            SStateChange.display = "none";
            this.setState({SpacesDropDownStyles:SStateChange}); 
        }
    }

    FormTreeData(l_TreeData) {
        var SelectedItems = [], SelectedBuildingIds = [];
        SelectedItems = l_TreeData;
        l_TreeData.forEach(element => {
            SelectedBuildingIds.push(element.buildingID);
        });

        SelectedBuildingIds = SelectedBuildingIds.filter((val, id, array) => array.indexOf(val) == id);
        var BuildingCollection = [];
        if (SelectedBuildingIds.length) {
            for (var k = 0; k < SelectedBuildingIds.length; k++) {
                var SelectedFloorIds = [], SelectedSpaceIds = [];
                var FloorInputCollection = [];
                var FilterBuildingData = SelectedItems.filter(x => x.buildingID == SelectedBuildingIds[k]);
                if (FilterBuildingData.length) {
                    FilterBuildingData.forEach(element => {
                        if (element.floorID !== 0) {
                            SelectedFloorIds.push(element.floorID);
                        }
                        else {
                            SelectedSpaceIds.push(element.spaceID);
                        }
                    });

                    if (SelectedFloorIds.length) {
                        SelectedFloorIds = SelectedFloorIds.filter((val, id, array) => array.indexOf(val) == id);
                        for (var i = 0; i < SelectedFloorIds.length; i++) {
                            var FilterData = SelectedItems.filter(x => x.floorID == SelectedFloorIds[i]);
                            if (FilterData !== undefined && FilterData.length) {
                                var FloorInput = <Label style={{ "height": "28px", "width": "176px"}} nodeType="FloorNode" FloorId={FilterData[0].floorID} className="buildingheaderlabel">{FilterData[0].floorName}</Label>
                                var SpaceInputCollection = [];
                                for (var j = 0; j < FilterData.length; j++) {
                                    if(FilterData[j].spaceID !== 0)
                                        SpaceInputCollection[j] = { title: <Label style={{ "height": "28px", "width": "176px"}} nodeType="SpaceNode" SpaceId={FilterData[j].spaceID} className="buildingheaderlabel">{FilterData[j].spaceName}</Label> };
                                }
                                FloorInputCollection[i] = { title: FloorInput, expanded: true, children: SpaceInputCollection };
                            }
                        }
                    }
                    if (SelectedSpaceIds !== undefined && SelectedSpaceIds !== null && SelectedSpaceIds.length) {
                        var StartPt = FloorInputCollection.length;
                        var j = 0;
                        for (var i = StartPt; i < (Number(StartPt) + Number(SelectedSpaceIds.length)); i++) {
                            var FilterData = SelectedItems.filter(x => x.spaceID == SelectedSpaceIds[j]);
                            FloorInputCollection[i] = { title: <Label style={{ "height": "28px", "width": "176px"}} nodeType="SpaceNode" SpaceId={FilterData[0].spaceID} className="buildingheaderlabel">{FilterData[0].spaceName}</Label> };
                            j++;
                        }
                    }
                    BuildingCollection[k] = { title: <Label style={{ "height": "28px", "width": "176px"}} nodeType="BuildingNode" BuildingId={FilterBuildingData[0].buildingID} className="buildingheaderlabel">{FilterBuildingData[0].buildingName}</Label>, expanded: true, children: FloorInputCollection };
                }
            }
        }
        let InitialData = [{
            title: this.props.AssociateTenantName,
            expanded: true,
            children: BuildingCollection
        }]
        this.setState({ treeData: InitialData });
    }

    constructor(props) {
        super(props);
        this.state = {
            Buildings: (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length) ? this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false) : "",
            SpacesDropDownStyles: {
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex:"9999",
                width:"400px", 
                maxHeight:"300px", 
                overflowY: "auto", 
                zIndex:"9999", 
                border: "1px solid black",
                backgroundColor:"white",
                display: "none"
            },
            FloorSpacesData:[],
            treeData: [],
            tenant_buildings_state: []
        };
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleMouseScroll = this.handleMouseScroll.bind(this);
        this.setSpaceWrapperRef = this.setSpaceWrapperRef.bind(this);
        this.ComputeSpaceStyle = this.ComputeSpaceStyle.bind(this);
        this.setSpace = this.setSpace.bind(this);
        this.LoadBuildingFloors = this.LoadBuildingFloors.bind(this);
    }

    setSpaceWrapperRef(node){
        this.spaceWrapperRef = node;
    }

    ComputeSpaceStyle(){
        var offset = ReactDOM.findDOMNode(this.refs.Spaces_in_Select_input).getBoundingClientRect();
        let StateChange = {...this.state.SpacesDropDownStyles};
        StateChange.display = "block";
        StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
        StateChange.left= parseInt(offset.left);
        this.setState({SpacesDropDownStyles:StateChange});
        this.LoadBuildingFloors();
    }

    setSpace()
    {
        let StateChange = {...this.state.SpacesDropDownStyles};
        StateChange.display = "none";
        
        this.setState({ SpacesDropDownStyles:StateChange }); 
        const actionResponse = this.props.GetBuildingAssociation(this.props.AssociaTetenantId);
        actionResponse.then((result) => {
            if(this.state.tenant_buildings_state !== undefined && this.state.tenant_buildings_state.length){
                this.FormTreeData(this.state.tenant_buildings_state);
            }
        })
    }

    LoadBuildingFloors() {
        var SelectedFloor = [], SelectedSpaces = [];
        var selectedOption = this.refs.buildings_in_Select_input.options.selectedIndex;
        var selectedSiteId = this.refs.buildings_in_Select_input.options[selectedOption].id;
        
        const SelectedObject = (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length) ? this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false && el.id == selectedSiteId) : "";
        
        SelectedFloor = SelectedObject[0] !== undefined ? SelectedObject[0].floors : [];
        SelectedSpaces = SelectedObject[0] !== undefined ? SelectedObject[0].spaces : [];
        if(this.props.getTenantAssociations !== undefined && this.props.getTenantAssociations.length){
            var lFloor = [], lSpace = [];
            var AssociatedBuildingFloor = this.props.getTenantAssociations.filter(x => x.buildingID == selectedSiteId);
            
            SelectedFloor.forEach((ele) => {
                var lSelectedFloor = AssociatedBuildingFloor.filter(x => x.floorID === ele.id);
                var lSelectedSpaces = ele.spaces;
                if (lSelectedSpaces.length) {
                    for (var i = 0; i < lSelectedFloor.length; i++) {
                        lSelectedSpaces = lSelectedSpaces.filter(x => x.id !== lSelectedFloor[i].spaceID);
                    }
                    var lineitem = {
                        "id": ele.id,
                        "name": ele.name,
                        "spaces": lSelectedSpaces,
                        "suites": []
                    }
                    lFloor.push(lineitem);
                } else {
                    if (lSelectedFloor.length === 0) {
                        var lineitem = {
                            "id": ele.id,
                            "name": ele.name,
                            "spaces": [],
                            "suites": []
                        }
                        lFloor.push(lineitem);
                    }
                }
            });

            lSpace = SelectedSpaces;
            SelectedSpaces.forEach((ele) => {
                var lSelectedSpaces = AssociatedBuildingFloor.filter(x => x.floorID === 0 && x.spaceID === ele.id);
                for(var i=0; i<lSelectedSpaces.length; i++){
                    lSpace = lSpace.filter(x => x.id !== lSelectedSpaces[i].spaceID);
                }
            });
            SelectedFloor = lFloor;
            SelectedSpaces = lSpace;
        }

        var l_Spacestdata = [], Spacelineitem = '';
        SelectedFloor.forEach(element => {
            var l_FloorName = element.name;
            var l_FloorId = element.id;

            if(element.spaces.length > 0){
                element.spaces.forEach(el => {
                Spacelineitem = {
                    "BuildingId" : selectedSiteId,
                    "BuildingName" : SelectedObject[0].name,
                    "Id": el.id,
                    "Name": el.name, 
                    "FloorName": l_FloorName,
                    "FloorId": l_FloorId,
                    "TenantId" : this.props.AssociaTetenantId
                    }
                    l_Spacestdata.push(Spacelineitem);
                });
            }
            else{
                let Spacelength = 0, BuildingLst = [];
                if(this.props.getWorkOrderBuildings != null && this.props.getWorkOrderBuildings != undefined && this.props.getWorkOrderBuildings.length > 0){
                    BuildingLst = this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false);
                    let TBuilding = BuildingLst.filter(el => el.id == selectedSiteId);
                    let TFloor = TBuilding[0].floors.filter(x => x.id === l_FloorId);
                    Spacelength = TFloor[0].spaces.length;
                }
                    
                if (Spacelength === 0) {
                    Spacelineitem = {
                        "BuildingId": selectedSiteId,
                        "BuildingName": SelectedObject[0].name,
                        "Id": 0,
                        "Name": "",
                        "FloorName": l_FloorName,
                        "FloorId": l_FloorId,
                        "TenantId": this.props.AssociaTetenantId
                    }
                    l_Spacestdata.push(Spacelineitem);
                }
            }
        });

        SelectedSpaces.forEach(element => {
            Spacelineitem = {
                "BuildingId" : selectedSiteId,
                "BuildingName" : SelectedObject[0].name,
                "Id": element.id,
                "Name": element.name, 
                "FloorName": "",
                "FloorId": 0,
                "TenantId" : this.props.AssociaTetenantId
            }
            l_Spacestdata.push(Spacelineitem);
        });

        this.setState({
            FloorSpacesData: l_Spacestdata
        });
    }

    CancelAssociation(){
        this.props.ChangeDisplayinWorkOrderTenant('TenantDetails');
    }



    render(){
        let BuildingsList = [], buildings_in_Select_input = [];
        if(this.props.getWorkOrderBuildings != null && this.props.getWorkOrderBuildings != undefined && this.props.getWorkOrderBuildings.length > 0)
            BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false);
       
        if(BuildingsList != null && BuildingsList != undefined && BuildingsList.length > 0)
        {
            buildings_in_Select_input = BuildingsList.map( el => (
                <option id={el.id}>{el.name}</option>
            ));
        }

        return(
            <div className="main_container">
            <div className="border_container">&nbsp;
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                    <div className="col-md-2">
                        <Button type="button" className="btn btn-gray" onClick={() => { this.CancelAssociation() }} >{"< Back"}</Button>
                    </div>
                </div>
                <br/>
                <br/>
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                    <div className="col-md-2">
                        <Label className="Custom_label">Building</Label><br/>
                        <select ref='buildings_in_Select_input' style={{width:'100%'}} onChange={this.LoadBuildingFloors}>
                        <option value="" disabled selected>Choose one</option>
                            {buildings_in_Select_input}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <Label className="Custom_label">Floor / Space</Label><br/>
                        <input type="text" ref='Spaces_in_Select_input' style={{width:'100%', height:'15'}} placeholder="Choose one" onClick={this.ComputeSpaceStyle} />
                    </div>
                
                </div>
                <SearchableSpaceDropDown name="Spacedropdown" refMethod={this.setSpaceWrapperRef} data={this.state.FloorSpacesData} elementStyle={this.state.SpacesDropDownStyles} setValue={this.setSpace} />
            </div>
        </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getTenantAssociations: state.WorkorderRootReducer.TenantAssociations
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        BuildingUnAssociation: (data) => dispatch(BuildingUnAssociation(data)),
        ChangeDisplayinWorkOrderTenant: (data) => dispatch(ChangeDisplayinWorkOrderTenant(data)),
        GetBuildingAssociation: (TenantId) => dispatch(GetBuildingAssociation(TenantId))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TenantAssociation);